<template>
  <div>
    <Heading v-if="!isCodeOnly" tag="h2">{{ $t('examples.instructions.writeTheCode') }}</Heading>
    <AddInstructionsForLanguage v-if="!isCodeOnly" :lang="langExample.language" :file-name="langExample.file_name" />
    <code-snippet :lang="langExample.prism_lang" :code="langExample.code.text" />
    <p v-if="!isCodeOnly"><ViewFullSourceLink :href="langExample.code.link" /></p>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { LanguageExample } from '@bifrost-dev-docs-mfe/common/types/examples';
import CodeSnippet from '@/components/markdown/widgets/CodeSnippet.vue';
import AddInstructionsForLanguage from '@/components/example/language-specific/AddInstructionsForLanguage.vue';
import Heading from '@/components/example/components/Heading.vue';
import ViewFullSourceLink from '@/components/example/components/ViewFullSourceLink.vue';

const props = defineProps({ langExample: { type: Object as PropType<LanguageExample>, required: true } });

const isCodeOnly = computed(() => props.langExample.code_only);
</script>
